import { Component, Input, Output, EventEmitter, ElementRef, HostListener, OnInit } from '@angular/core';
import { CustomToastrService } from '@app/shared/custom-toastr/custom-toastr.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { rolesdef } from '@app/constants/role-def';
import { MessageService } from 'primeng/api';
import { label } from '@app/constants/labels';


// import { SnackbarService } from '@quartzds/apps-industry-angular';
@Component({
  selector: 'app-device-context-menu',
  standalone: false,
  templateUrl: './device-context-menu.component.html',
  styleUrls: ['./device-context-menu.component.scss'],
  providers: [MessageService]
})
export class DeviceContextMenuComponent implements OnInit {
  @Input() item: any;
  @Input() role: any;
  @Input() isVisible: boolean = false;
  @Output() toggle = new EventEmitter<any>();
  @Output() shareDevice = new EventEmitter<any>();
  @Output() remoteLinkUpdated = new EventEmitter<void>();

  isDialogOpen: boolean = false;
  installerEmail: string = '';
  installerEmailValid: boolean = false;
  installerId: string = '';
  isAgreementChecked: boolean = false;
  isSharedDeviceDetails: boolean = false;
  installerMailId: string = 'test@gmail.com;'
  
  isRemoteLinkModal: boolean = false; 
  selectedCoolerRexName: string = '';
  selectedDongleId: any;
  selectedRemoteLink: string = '';
  entredRemoteLink: string = '';
  roles = rolesdef;
  showRexModal: boolean = false;
  deviceLocation: string = '';
  stopServiceEnabled: boolean = false;
  isCheckingEmail: boolean = false;
  isRevokeDeviceModal: boolean = false;
 labels: any = label;
 isRevokeAgreementChecked: boolean = false;

  constructor(
    private elementRef: ElementRef,
    private readonly baseService: BaseAPIService,
    private messageService: MessageService,
    private toastr: CustomToastrService
  ) {}

  ngOnInit(): void {
    this.deviceLocation = this.item?.locationCountry;
    this.installerId = this.item?.assignedInstallerId;
  }

  get isFormValid(): boolean {
    if (this.item?.assignedInstallerId) {
      return this.isAgreementChecked;
    }
    return this.installerEmail.trim() !== '' && this.isAgreementChecked;
  }

  onCheckEmail(event: any): void {
    this.isCheckingEmail = true;
    this.installerEmail = event.target?.value || event.detail?.value || '';
    this.installerEmailValid = false;
    if (this.installerEmail && this.installerEmail.includes('@')) {
      this.baseService.GET(`/User/IsValidInstaller?emailid=${encodeURIComponent(this.installerEmail)}`).subscribe({
        next: (res: any) => {
          this.installerEmailValid = true;
          this.isCheckingEmail = false;
          if (res && res.id) {
            this.installerId = res.id;
          } else {
            this.installerId = '';
          }
        },
        error: (err) => {
          this.isCheckingEmail = false;
          this.installerEmailValid = false;
          this.installerId = '';
        }
      });
    } else {
      this.isCheckingEmail = false;
    }
  }

  onCheckboxChange(event: any, value?: string): void {
    this.isAgreementChecked = event.target?.checked ?? event.detail?.checked ?? false;
    if (value === 'stopService') {
      this.stopServiceEnabled = true;
      return;
    }
  }

  onShareConfirm(){
    if (!this.isFormValid) {
      this.toastr.show('warning', 'Please enter a valid installer email and accept to share the device.');
      return;
    }
    const deviceId = encodeURIComponent(this.item?.id);
    const installerId = encodeURIComponent(this.installerId);

    if (this.stopServiceEnabled) {
      // Call revoke API
      const revokeApiUrl = `/Device/RevokeSharedDeviceWithInstaller/${deviceId}`;
      this.baseService.DELETE(revokeApiUrl).subscribe({
        next: () => {
          this.toastr.show('success', 'Device sharing revoked successfully.');
          this.isDialogOpen = false;
          this.remoteLinkUpdated.emit();
        },
        error: (err) => {
          let msg = 'Failed to revoke device sharing.';
          if (err && err.error) {
            if (typeof err.error === 'string') {
              msg = err.error;
            } else if (err.error.message) {
              msg = err.error.message;
            }
          }
          this.toastr.show('error', msg);
        }
      });
      return;
    }

    const apiUrl = `/Device/ShareDeviceWithInstaller/${deviceId}/${installerId}`;
    this.baseService.POST(apiUrl, {}).subscribe({
      next: () => {
        this.toastr.show('success', 'Shared device successfully.');
        this.isDialogOpen = false;
        this.remoteLinkUpdated.emit();
      },
      error: (err) => {
        let msg = 'Failed to share device.';
        if (err && err.error) {
          if (typeof err.error === 'string') {
            msg = err.error;
          } else if (err.error.message) {
            msg = err.error.message;
          }
        }
        this.toastr.show('error', msg);
      }
    });
  }

  confirmRevokeDevice(item: any): void {
    
    const deviceId = encodeURIComponent(item?.id);
    const revokeApiUrl = `/Device/RelinquishmentDeviceAccess/${deviceId}`;
    
    this.baseService.DELETE(revokeApiUrl).subscribe({
      next: () => {
        this.isRevokeDeviceModal = false;
        this.toastr.show('success', 'Device sharing revoked successfully.');
        this.remoteLinkUpdated.emit();
      },
      error: (err) => {
        let msg = 'Failed to revoke device sharing.';
        if (err && err.error) {
          if (typeof err.error === 'string') {
            msg = err.error;
          } else if (err.error.message) {
            msg = err.error.message;
          }
        }
        this.toastr.show('error', msg);
      }
    });
  }

  toggleMenu(): void {
    this.toggle.emit(this.item);
  }

  onShareDevice(): void {
    this.isDialogOpen = true;
    this.toggle.emit(null); // Close the context menu
    this.shareDevice.emit(this.item);
  }

  onDialogClose(): void {
    this.isDialogOpen = false;
    this.installerEmail = '';
    this.isAgreementChecked = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isVisible && !this.elementRef.nativeElement.contains(event.target)) {
      this.toggle.emit(null);
    }
  }

  addUpdateRemoteLink(data: any){
    this.isRemoteLinkModal = true;
    this.toggle.emit(null); // Close the context menu
    this.selectedCoolerRexName = data.name;
    this.selectedDongleId = data.dongleUId;
    this.selectedRemoteLink = data.remoteLink;
    this.entredRemoteLink = data.remoteLink;
  }

  onRemoteLinkDialogClose(){
    this.isRemoteLinkModal = false;
  }

  saveRex(){
    let apiUrl = `/Device/UpdateREXRemoteLink/${this.selectedDongleId}`;
    if (this.entredRemoteLink !== null && this.entredRemoteLink !== undefined && this.entredRemoteLink !== '') {
      let isValid = true;
      try {
        new URL(this.entredRemoteLink);
      } catch {
        isValid = false;
      }
      if (!isValid) {
        this.toastr.show('warning', 'Please enter a valid remote link URL.');
        return;
      }
      const remoteLinkParam = encodeURIComponent(this.entredRemoteLink);
      apiUrl += `?remoteLink=${remoteLinkParam}`;
    }
    this.baseService.PATCH(apiUrl, {} ).subscribe(
      (res: any) => {
        this.isRemoteLinkModal = false;
        this.remoteLinkUpdated.emit();
        this.toastr.show('success', 'Remote link updated successfully.');
      },
      (error: any) => {
        this.toastr.show('error', 'Failed to update remote link.');
        this.isRemoteLinkModal = false;
      }
    );
  }

  revokeDeviceModal(item: any): void {
    console.log('Item for revocation:', item);
    this.isRevokeDeviceModal = true;
  }

  onRevokeModalClose(): void {
    this.isRevokeDeviceModal = false;
  }

  onRevokeAgreementCheckboxChange(event: any): void {
    this.isRevokeAgreementChecked = event.target?.checked ?? event.detail?.checked ?? false;
  }

}
